import React, { useState } from 'react';
import { Input, Button, message } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import axios from 'axios';
import { AgentTierDemoContent } from './admin/AgentTierDemo';

// 公开的「二次TS·收益演示」页：需输入随机访问密码才能查看
const TsDemoPublic = () => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [unlocked, setUnlocked] = useState(false);

  const submit = async () => {
    const value = (code || '').trim().toUpperCase();
    if (!value) { message.warning('请输入访问密码'); return; }
    setLoading(true);
    try {
      const res = await axios.get('/ts/demo-share/verify', { params: { code: value } });
      if (res.data && res.data.success && res.data.valid) {
        setUnlocked(true);
      } else {
        message.error('密码不正确或已失效');
      }
    } catch (e) {
      message.error(e.response?.data?.message || '校验失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  if (unlocked) {
    return (
      <div style={{ minHeight: '100vh', background: '#f0f2f5', padding: '16px 12px' }}>
        <div style={{ maxWidth: 920, margin: '0 auto', background: '#fff', borderRadius: 12, overflow: 'hidden', boxShadow: '0 8px 30px rgba(0,0,0,0.08)' }}>
          <AgentTierDemoContent />
        </div>
        <div style={{ textAlign: 'center', color: '#bbb', fontSize: 12, margin: '18px 0' }}>本页为收益演示，实际收益以真实业务为准</div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, background: 'linear-gradient(135deg,#6366F1,#8B5CF6)' }}>
      <div style={{ width: '100%', maxWidth: 380, background: '#fff', borderRadius: 18, padding: '32px 24px', boxShadow: '0 16px 40px rgba(0,0,0,0.18)', textAlign: 'center' }}>
        <div style={{ width: 64, height: 64, borderRadius: '50%', background: 'linear-gradient(135deg,#6366F1,#8B5CF6)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
          <LockOutlined style={{ fontSize: 28, color: '#fff' }} />
        </div>
        <div style={{ fontSize: 20, fontWeight: 800, color: '#262626' }}>二次TS · 收益演示</div>
        <div style={{ fontSize: 13, color: '#8c8c8c', marginTop: 6, marginBottom: 22 }}>本页受保护，请输入访问密码</div>
        <Input
          size="large"
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          onPressEnter={submit}
          placeholder="请输入访问密码"
          maxLength={12}
          style={{ textAlign: 'center', letterSpacing: 4, fontSize: 18, fontWeight: 700, fontFamily: 'monospace' }}
          autoFocus
        />
        <Button type="primary" size="large" block loading={loading} onClick={submit} style={{ marginTop: 16, height: 46, fontSize: 16, borderRadius: 10 }}>
          进入演示
        </Button>
        <div style={{ fontSize: 12, color: '#bbb', marginTop: 16 }}>密码由代理提供 · 不区分大小写</div>
      </div>
    </div>
  );
};

export default TsDemoPublic;
